/* «Сделать кружок» и «Заставить говорить» с итога «Сменить голос в записи» / «Почистить запись» (APP-SPEC-5 §16, цепочки):
   готовая запись передаётся «Говорящему кружку» («Кружок из аудио» или персонаж говорит записью) только как новая загрузка.
   Файл живёт в памяти вкладки (как photo-result-entry.ts и video-result-entry.ts): в хранилище не пишутся ни файл, ни адреса. */
import { openStudioTarget } from '../studio/studio-navigation';

export type VoiceResultUse = 'audio' | 'talk';
export interface VoiceResultEntry {
  owner: number;
  orderId: number;
  revision: number;
  index: number;
  file: File;
  use: VoiceResultUse;
  createdAt: number;
}
let entry: VoiceResultEntry | null = null;
/** Адрес «Говорящего кружка»: «Кружок из аудио» (who audio) или персонаж говорит записью (who char, речь — запись) */
export function voiceResultTarget(use: VoiceResultUse) {
  return use === 'audio'
    ? { screen: 'circle', who: 'audio', options: { source: 'audio', speech: 'audio' } }
    : { screen: 'circle', who: 'char', options: { speech: 'audio' } };
}
export function stageVoiceResult(value: Omit<VoiceResultEntry, 'createdAt'>) {
  entry = { ...value, createdAt: Date.now() };
  openStudioTarget(voiceResultTarget(value.use));
}
export function readVoiceResult() {
  if (entry && Date.now() - entry.createdAt > 20 * 60 * 1000) entry = null;
  return entry;
}
export function clearVoiceResult(expected: VoiceResultEntry) {
  if (entry === expected) entry = null;
}
